// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Stacking layer for context menus, tooltips, and other anchored overlays. Sits above
 * .modalsContainer because it appears later in the DOM — both have z-index: 1, and among
 * siblings with equal z-index the later element wins.
 *
 * Cross-reference: Modal.css (.modalsContainer), index.html (DOM order),
 * hooks/index.tsx (overlayPortal, modalPortal), Popup.tsx, Modal.tsx.
 * Update all of these if the stacking strategy changes.
 */
.overlayContainer {
  position: absolute;
  width: 0;
  height: 0;
  z-index: 1;
}

.menusFile {
  position: absolute;
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #ccc;
  box-sizing: border-box;
  box-shadow: 0 3px 11px #0002;
  border-radius: 3px;
  --spacing-w: 13px;
  --spacing-h: 11px;
  overflow: hidden;
}

/*
 * Mouse users get a denser menu that matches the row it was opened from (see
 * --music-padding-v/-h and --music-item-font-size in Music/index.css — those
 * variables are scoped to .music and don't reach this portaled menu, so the
 * matching values are repeated here). Touch keeps the larger default above.
 */
:root[data-input-mode="mouse"] .menusFile {
  --spacing-w: 12px;
  --spacing-h: 8px;
  font-size: 14px;
}

.menusFileButton {
  font-size: inherit;
  border: 0;
  padding: 0;
  margin: 0;
  background: none;
  padding: var(--spacing-h) var(--spacing-w);
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  border: 2px solid transparent;
  cursor: pointer;
}

.menusFileButtonLabel {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.menusFileButtonShortcut {
  color: #666;
  flex: none;
  font-size: 0.86em;
}

.menusFileButton:focus,
.menusFileButton:active {
  background: #d0f4ff;
  border: var(--outline-active);
  border-radius: 3px;
  outline: none;
}

.menusFileButton > .icon {
  margin-right: var(--spacing-w);
}

.menusFileButton:hover {
  background-color: #eee;
}

@keyframes menudown {
  from { opacity: 0; transform: translateY(-10px); pointer-events: none; }
  to   { opacity: 1; transform: translateY(0); }
}

@keyframes menuup {
  from { opacity: 0; transform: translateY(10px); pointer-events: none; }
  to   { opacity: 1; transform: translateY(0); }
}

.menusFileAnimateDown {
  animation: menudown 80ms;
}

.menusFileAnimateUp {
  animation: menuup 80ms;
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/Menus.css"],"names":[],"mappings":"AAAA;;;;;;;;EAQE;AACF;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;;EAKE;AACF;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE,oBAAoB,EAAE;EACvE,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE,oBAAoB,EAAE;EACtE,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["/*\n * Stacking layer for context menus, tooltips, and other anchored overlays. Sits above\n * .modalsContainer because it appears later in the DOM — both have z-index: 1, and among\n * siblings with equal z-index the later element wins.\n *\n * Cross-reference: Modal.css (.modalsContainer), index.html (DOM order),\n * hooks/index.tsx (overlayPortal, modalPortal), Popup.tsx, Modal.tsx.\n * Update all of these if the stacking strategy changes.\n */\n.overlayContainer {\n  position: absolute;\n  width: 0;\n  height: 0;\n  z-index: 1;\n}\n\n.menusFile {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border: 1px solid #ccc;\n  box-sizing: border-box;\n  box-shadow: 0 3px 11px #0002;\n  border-radius: 3px;\n  --spacing-w: 13px;\n  --spacing-h: 11px;\n  overflow: hidden;\n}\n\n/*\n * Mouse users get a denser menu that matches the row it was opened from (see\n * --music-padding-v/-h and --music-item-font-size in Music/index.css — those\n * variables are scoped to .music and don't reach this portaled menu, so the\n * matching values are repeated here). Touch keeps the larger default above.\n */\n:root[data-input-mode=\"mouse\"] .menusFile {\n  --spacing-w: 12px;\n  --spacing-h: 8px;\n  font-size: 14px;\n}\n\n.menusFileButton {\n  font-size: inherit;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  background: none;\n  padding: var(--spacing-h) var(--spacing-w);\n  text-align: left;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  border: 2px solid transparent;\n  cursor: pointer;\n}\n\n.menusFileButtonLabel {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.menusFileButtonShortcut {\n  color: #666;\n  flex: none;\n  font-size: 0.86em;\n}\n\n.menusFileButton:focus,\n.menusFileButton:active {\n  background: #d0f4ff;\n  border: var(--outline-active);\n  border-radius: 3px;\n  outline: none;\n}\n\n.menusFileButton > .icon {\n  margin-right: var(--spacing-w);\n}\n\n.menusFileButton:hover {\n  background-color: #eee;\n}\n\n@keyframes menudown {\n  from { opacity: 0; transform: translateY(-10px); pointer-events: none; }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes menuup {\n  from { opacity: 0; transform: translateY(10px); pointer-events: none; }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.menusFileAnimateDown {\n  animation: menudown 80ms;\n}\n\n.menusFileAnimateUp {\n  animation: menuup 80ms;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
